module.exports = __webpack_public_path__ + "img/GAME_DICTATION1.15f55af9.jpg";